import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-trust-strip',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './trust-strip.component.html',
  styleUrl: './trust-strip.component.scss',
})
export class TrustStrip {}
